import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Header = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navLinkClass = (path: string) => {
    const base = "text-sm font-medium transition-colors";
    return isActive(path)
      ? `${base} text-foreground border-b-2 border-primary pb-1`
      : `${base} text-muted-foreground hover:text-foreground`;
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md px-4 py-3 lg:px-6">
      {/* Mobile: flex layout */}
      <div className="flex sm:hidden items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-foreground">
          <Logo size={32} />
          <h2 className="text-foreground text-lg font-bold leading-tight tracking-tight">Clawstarter</h2>
        </Link>
        <nav className="flex items-center gap-4">
          <Link to="/explore" className={navLinkClass('/explore')}>
            Explore
          </Link>
          <Link to="/how-it-works" className={navLinkClass('/how-it-works')}>
            How It Works
          </Link>
        </nav>
      </div>

      {/* Desktop: centered nav */}
      <div className="hidden sm:block relative">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-foreground z-10">
            <Logo size={32} />
            <h2 className="text-foreground text-lg font-bold leading-tight tracking-tight">Clawstarter</h2>
          </Link>
          <div className="flex items-center justify-end gap-3 z-10">
          </div>
        </div>
        <nav className="absolute inset-0 flex items-center justify-center gap-6 pointer-events-none">
          <Link to="/" className={`pointer-events-auto ${navLinkClass('/')}`}>
            Home
          </Link>
          <Link to="/explore" className={`pointer-events-auto ${navLinkClass('/explore')}`}>
            Explore
          </Link>
          <Link to="/how-it-works" className={`pointer-events-auto ${navLinkClass('/how-it-works')}`}>
            How It Works
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
